import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ColorPicker from './ColorPicker';
import Form from 'react-bootstrap/Form';
import FontPicker from './FontPicker';
import {Action} from '../../../system/buttons';

export default class CaloriesEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {...props.configuration};
  }

  handleChange = (property) => (value) => {
    let f = {};
    f[property] = value;
    this.setState(f);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState !== this.state) {
      this.props.onUpdate(this.state);
    }
  }

  render() {
    return (
      <>
        <BasicFormElement label={'Font color'}>
          <ColorPicker
            color={this.state.fontColor}
            onChangeComplete={this.handleChange('fontColor')}
          />
        </BasicFormElement>

        <FontPicker
          font={this.state.font}
          onChange={(font) => this.handleChange('font')(font)}
        />

        <BasicFormElement label={'Age'}>
          <Form.Control
            type="number"
            value={this.state.age}
            onChange={(e) => this.handleChange('age')(e.target.value)}
          />
        </BasicFormElement>

        <BasicFormElement label={'Weight(in kg)'}>
          <Form.Control
            type="number"
            value={this.state.weight}
            onChange={(e) => this.handleChange('weight')(e.target.value)}
          />
        </BasicFormElement>

        <Form.Group as={Row}>
          <Form.Label column sm="2">
            Alignment
          </Form.Label>
          <Col sm="3">
            <Form.Control
              as="select"
              value={this.state.alignment}
              onChange={(e) => this.setState({alignment: e.target.value})}
            >
              <option key={1}>left</option>
              <option key={2}>center</option>
              <option key={3}>right</option>
            </Form.Control>
          </Col>
        </Form.Group>

        <Action onClick={() => this.props.onSave(this.state)}>
          Save settings
        </Action>
      </>
    );
  }
}

const BasicFormElement = ({label, children}) => {
  return (
    <Form.Group as={Row}>
      <Form.Label column sm="2">
        {label}
      </Form.Label>
      <Col sm="3">{children}</Col>
    </Form.Group>
  );
};
